export default __webpack_public_path__ + "img/ed9704e7d729ef11f23e58f8ae0ceace.svg";